import { render, staticRenderFns } from "./MediumPieChartDiagram.vue?vue&type=template&id=72a6abcc"
import script from "./MediumPieChartDiagram.vue?vue&type=script&lang=js"
export * from "./MediumPieChartDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports